import React from "react";
import IIntegration from "../../models/IIntegration";
import { IMenuItem } from "../../models/IMenuItem";
import { FormErrors } from "../forms/FormErrors";
import createInputHandlers from "../forms/inputHandlers";
import IntegrationDetailEditableSummaryCard from "./IntegrationDetailEditableSummaryCard";
import { IntegrationDetailReadOnlySummaryCard } from "./IntegrationDetailReadOnlySummaryCard";

interface IIntegrationDetailSummaryProps {
  form: IIntegration;
  formErrors: FormErrors<IIntegration>;
  allowEdit: boolean;
  setAllowEdit: (val: boolean) => void;
  setForm: (val: IIntegration) => void;
  cancelEdit: () => void;
  handleSave: () => void;
}

export const IntegrationDetailSummary = (props: IIntegrationDetailSummaryProps) => {
  const { form, formErrors, allowEdit, setAllowEdit, setForm, cancelEdit, handleSave } = props;

  const { handleChange } = createInputHandlers<IIntegration>(form, setForm);

  const handleOptionChange = (key: keyof IIntegration) => (option: IMenuItem | null) => {
    if (option === null) {
      option = {
        ID: 0,
        Name: "",
      };
    }

    setForm({
      ...form,
      [key]: option,
    });
  };

  return (
    <>
      {allowEdit ? (
        <IntegrationDetailEditableSummaryCard
          form={form}
          handleChange={handleChange}
          handleOptionChange={handleOptionChange}
          formErrors={formErrors}
          cancelEdit={cancelEdit}
          handleSave={handleSave}
        />
      ) : (
        <IntegrationDetailReadOnlySummaryCard model={form} setAllowEdit={setAllowEdit} />
      )}
    </>
  );
};
